import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { workingTreeAtom } from './atoms'
import { ReplacementTable } from './ReplacementTable'
import { ReplacementInputs } from './ReplacementInputs'
import { ReplacedTable } from './ReplacedTable'
import { ExcludedTable } from './ExcludedTable'
import { UrlSwap } from '../../../domains/content/features/url-swap/UrlSwap'

type ReplaceMode = 'text' | 'url'

export function FindAndReplace(ids: { treeId: string; versionId: string }) {
  const treeData = useGetTreeById(ids)
  useSetAtom(workingTreeAtom)(treeData)
  const [mode, setMode] = useState<ReplaceMode>('text')

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: ReplaceMode,
  ) => {
    setMode(newValue)
  }

  return (
    <Box>
      {/* Tabs for mode selection */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs
          value={mode}
          onChange={handleTabChange}
          aria-label="replace mode tabs"
        >
          <Tab label="Text Replace" value="text" />
          <Tab label="URL Replace from Spreadsheet" value="url" />
        </Tabs>
      </Box>

      {/* Text Replace Mode */}
      {mode === 'text' && (
        <Box>
          <Box padding="10px">
            The search string and replacement string are case sensitive so you
            want to make sure you get the case correct for both.
          </Box>
          <Box padding="10px">
            <ReplacementInputs />
          </Box>
          <Box padding="10px">
            <ReplacementTable />
          </Box>
          <Box padding="10px">
            <ReplacedTable />
          </Box>
          <Box padding="10px">
            <ExcludedTable />
          </Box>
        </Box>
      )}

      {/* URL Replace Mode */}
      {mode === 'url' && (
        <Box padding="10px">
          <UrlSwap treeId={ids.treeId} versionId={ids.versionId} />
        </Box>
      )}
    </Box>
  )
}
